import PropTypes from 'prop-types';
import { useFormContext } from 'react-hook-form';

import { useIntl } from '@zenbusiness/application-commons-intl';

import AutocompleteField from '#client/components/AutocompleteField';
import Fieldset from '#client/components/Fieldset';

import useIndustryField from './hooks/useIndustryField';

const IndustryFieldset = ({ fieldsConfig }) => {
  const { formatMessage } = useIntl();
  const { formState } = useFormContext();
  const { isSubmitting } = formState;

  const { industry } = fieldsConfig || {};

  const { show: showIndustry, ...industryProps } = industry || {};

  return (
    <Fieldset disabled={isSubmitting} gap={1}>
      <AutocompleteField
        {...industryProps}
        handleField={useIndustryField}
        label={formatMessage({ id: 'shopping.page.industry.form.field.label.industry' })}
      />
    </Fieldset>
  );
};

IndustryFieldset.propTypes = {
  fieldsConfig: PropTypes.object
};

export default IndustryFieldset;
